// extracted by mini-css-extract-plugin
module.exports = {"title":"application_card_header-module_title_cce84","titleValue":"application_card_header-module_titleValue_e2116","subTitle":"application_card_header-module_subTitle_8862b"};